import { Component } from 'react'
import * as Sentry from '@sentry/react'

// The inbound-appointment section is optional decoration on the two
// mission-critical reception screens. If anything inside it throws,
// receiving must keep working: degrade to nothing. Report to Sentry as well,
// because rendering null is otherwise the one React crash in the app that
// produces no evidence anywhere.
export class SectionErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    console.error('InboundAppointmentSection crashed', error, info)
    Sentry.captureException(error, { contexts: { react: { componentStack: info.componentStack } } })
  }

  render() {
    if (this.state.hasError) return null
    return this.props.children
  }
}
